import {Directive, Renderer,ElementRef,Input} from '@angular/core';
import {DatePipe} from '@angular/common';

@Directive({
  selector: '[date-format]'
})
export class DateFormatDirective {

  @Input('date-format') val;

  value:string;
  date1:string;
  date:any;
  pipe = new DatePipe('en-US');

  constructor(private el: ElementRef,
              private renderer: Renderer) {
    setTimeout(() => {
      this.check();
    }, 0);
  }

  check (){

    if(this.val != '0000-00-00 00:00:00' && this.val != null){
      this.date = new Date(this.val.replace(' ', 'T'));
      var d1 = this.el.nativeElement;
      if (Object.prototype.toString.call(this.date) === "[object Date]") {
        // it is a date
        if (isNaN(this.date.getTime())) {  // d.valueOf() could also work
          // date is not valid
        } else {
          // date is valid
          this.value = this.pipe.transform(this.date, 'dd/MM/yyyy');
          if(this.value != ""){
            d1.insertAdjacentHTML('beforeend', '<span>'+this.value+'</span>');
          }
        }
      } else {
        // not a date
      }
    }
  }
}

export const DateFormat_DIRECTIVES = [
  DateFormatDirective
];



// WEBPACK FOOTER //
// /app/src/app/directives/date-format/date-format.directive.ts